import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Switch, Carousel } from 'antd';
import { VCIbox } from './variabilityInfoBox';
import { FieldVariabilityCard } from './FieldCarousal';
import { VIToggleSwitch, ViFieldDiv } from '../../../features/GoogleMap/styles';
import { VariabilityIndexIconMultifield } from '../../../common/Icons';

export const VariabilityCarousal = (props) => {
  const { t } = useTranslation();
  const {
    isMultiFieldPage,
    enableFieldVariability,
    showFieldVICard,
    selectedFieldId,
    selectedFields,
    isVIToggleSwitchVisible,
    setEnableFieldVariability,
    carouselRef,
    handleFieldClickfromCarousal,
    EditFieldList,
    fields
  } = props;

  const fieldsPerSlide = 3;

  let variabilityIndexList = useSelector(
    (state) => state.variabilityIndexForFields.variabilityIndexList
  ).sort((a, b) => {
    const vxcA = a.index.vxc ? parseFloat(a.index.vxc) : -1;
    const vxcB = b.index.vxc ? parseFloat(b.index.vxc) : -1;
    return vxcB - vxcA;
  });

  return (
    <>
      {isMultiFieldPage && enableFieldVariability && showFieldVICard && (
        <VCIbox
          fieldInfo={variabilityIndexList.find((item) => item.field_id === selectedFieldId)}
          fieldArea={selectedFields?.find((item) => item.id === selectedFieldId)?.declared_area}
        />
      )}
      {isMultiFieldPage && isVIToggleSwitchVisible && (
        <VIToggleSwitch id='VI-toggle-switch'>
          <div>
            <VariabilityIndexIconMultifield />
            <span style={{ marginLeft: '5px' }}>{t('Field Variability')}</span>
          </div>
          <Switch
            id='VI-toggle-switch-input'
            checked={enableFieldVariability}
            onChange={(e) => {
              setEnableFieldVariability(e);
            }}
          />
        </VIToggleSwitch>
      )}
      {isMultiFieldPage && enableFieldVariability && (
        <ViFieldDiv id='Vi-field-div'>
          <Carousel
            infinite={false}
            ref={carouselRef}
            dots={selectedFields.length >= 3}
            slidesToShow={fieldsPerSlide}
            slidesToScroll={fieldsPerSlide}
            swipeToSlide={true}
            touchThreshold={10}
            centerPadding={'12px'}
            variableWidth={true}
          >
            {selectedFieldId ? (
              <FieldVariabilityCard
                data={selectedFields?.find((item) => item.id === selectedFieldId)}
                key={selectedFieldId}
                VI={
                  variabilityIndexList?.find((item) => item.field_id === selectedFieldId)?.index.vxc
                }
                fields={fields}
                handleFieldClickfromCarousal={handleFieldClickfromCarousal}
                selectedFieldId={selectedFieldId}
              />
            ) : (
              variabilityIndexList.map((item) => {
                const field = (EditFieldList && EditFieldList[item.field_id]) || {};
                return (
                  <FieldVariabilityCard
                    data={field}
                    key={(field && field.id) || ''}
                    VI={item.index.vxc}
                    fields={fields}
                    handleFieldClickfromCarousal={handleFieldClickfromCarousal}
                    selectedFieldId={selectedFieldId}
                  />
                );
              })
            )}
            {}
          </Carousel>
        </ViFieldDiv>
      )}
    </>
  );
};

VariabilityCarousal.propTypes = {
  isMultiFieldPage: PropTypes.any,
  enableFieldVariability: PropTypes.any,
  showFieldVICard: PropTypes.any,
  selectedFieldId: PropTypes.any,
  selectedFields: PropTypes.any,
  isVIToggleSwitchVisible: PropTypes.any,
  setEnableFieldVariability: PropTypes.any,
  carouselRef: PropTypes.any,
  handleFieldClickfromCarousal: PropTypes.any,
  EditFieldList: PropTypes.any,
  fields: PropTypes.any
};
